/**
 * Human labels for raw technical identifiers shown to staff.
 * The raw value stays available (tooltip / code) for support and search.
 */

/** "license.revoke" / "update_release_publish" -> "License revoke" */
export function humanizeAction(action: string): string {
  const words = action.replace(/[._:/-]+/g, ' ').replace(/\s+/g, ' ').trim();
  if (!words) return action;
  return words.charAt(0).toUpperCase() + words.slice(1);
}
